/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.InsightLinkReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The InsightLinkReport model module.
   * @module model/InsightLinkReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>InsightLinkReport</code>.
   * @alias module:model/InsightLinkReport
   * @class
   */
  var exports = function() {
    var _this = this;























  };

  /**
   * Constructs a <code>InsightLinkReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InsightLinkReport} obj Optional instance to populate.
   * @return {module:model/InsightLinkReport} The populated <code>InsightLinkReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('BusinessModelCanvasItemID')) {
        obj['BusinessModelCanvasItemID'] = ApiClient.convertToType(data['BusinessModelCanvasItemID'], 'Integer');
      }
      if (data.hasOwnProperty('DashboardPageBlockID')) {
        obj['DashboardPageBlockID'] = ApiClient.convertToType(data['DashboardPageBlockID'], 'Integer');
      }
      if (data.hasOwnProperty('DashboardPageID')) {
        obj['DashboardPageID'] = ApiClient.convertToType(data['DashboardPageID'], 'Integer');
      }
      if (data.hasOwnProperty('NewsEntryID')) {
        obj['NewsEntryID'] = ApiClient.convertToType(data['NewsEntryID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyDescriptionID')) {
        obj['StrategyDescriptionID'] = ApiClient.convertToType(data['StrategyDescriptionID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicGoalID')) {
        obj['StrategicGoalID'] = ApiClient.convertToType(data['StrategicGoalID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicGoalMilestoneID')) {
        obj['StrategicGoalMilestoneID'] = ApiClient.convertToType(data['StrategicGoalMilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicGoalMilestoneStatusUpdateID')) {
        obj['StrategicGoalMilestoneStatusUpdateID'] = ApiClient.convertToType(data['StrategicGoalMilestoneStatusUpdateID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicProgramID')) {
        obj['StrategicProgramID'] = ApiClient.convertToType(data['StrategicProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicProgramStatusUpdateID')) {
        obj['StrategicProgramStatusUpdateID'] = ApiClient.convertToType(data['StrategicProgramStatusUpdateID'], 'Integer');
      }
      if (data.hasOwnProperty('WorkshopID')) {
        obj['WorkshopID'] = ApiClient.convertToType(data['WorkshopID'], 'Integer');
      }
      if (data.hasOwnProperty('WorkshopWidgetID')) {
        obj['WorkshopWidgetID'] = ApiClient.convertToType(data['WorkshopWidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('MeetingID')) {
        obj['MeetingID'] = ApiClient.convertToType(data['MeetingID'], 'Integer');
      }
      if (data.hasOwnProperty('AlertID')) {
        obj['AlertID'] = ApiClient.convertToType(data['AlertID'], 'Integer');
      }
      if (data.hasOwnProperty('DialogBatchID')) {
        obj['DialogBatchID'] = ApiClient.convertToType(data['DialogBatchID'], 'Integer');
      }
      if (data.hasOwnProperty('WorkspaceMindmapID')) {
        obj['WorkspaceMindmapID'] = ApiClient.convertToType(data['WorkspaceMindmapID'], 'Integer');
      }
      if (data.hasOwnProperty('DrillUri')) {
        obj['DrillUri'] = ApiClient.convertToType(data['DrillUri'], 'String');
      }
      if (data.hasOwnProperty('DrillUriIconIdentifier')) {
        obj['DrillUriIconIdentifier'] = ApiClient.convertToType(data['DrillUriIconIdentifier'], 'String');
      }
      if (data.hasOwnProperty('InsightID')) {
        obj['InsightID'] = ApiClient.convertToType(data['InsightID'], 'Integer');
      }
      if (data.hasOwnProperty('CategoryID')) {
        obj['CategoryID'] = ApiClient.convertToType(data['CategoryID'], 'Integer');
      }
      if (data.hasOwnProperty('DrillTitle')) {
        obj['DrillTitle'] = ApiClient.convertToType(data['DrillTitle'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} BusinessModelCanvasItemID
   */
  exports.prototype['BusinessModelCanvasItemID'] = undefined;
  /**
   * @member {Integer} DashboardPageBlockID
   */
  exports.prototype['DashboardPageBlockID'] = undefined;
  /**
   * @member {Integer} DashboardPageID
   */
  exports.prototype['DashboardPageID'] = undefined;
  /**
   * @member {Integer} NewsEntryID
   */
  exports.prototype['NewsEntryID'] = undefined;
  /**
   * @member {Integer} StrategyDescriptionID
   */
  exports.prototype['StrategyDescriptionID'] = undefined;
  /**
   * @member {Integer} StrategicGoalID
   */
  exports.prototype['StrategicGoalID'] = undefined;
  /**
   * @member {Integer} StrategicGoalMilestoneID
   */
  exports.prototype['StrategicGoalMilestoneID'] = undefined;
  /**
   * @member {Integer} StrategicGoalMilestoneStatusUpdateID
   */
  exports.prototype['StrategicGoalMilestoneStatusUpdateID'] = undefined;
  /**
   * @member {Integer} StrategicProgramID
   */
  exports.prototype['StrategicProgramID'] = undefined;
  /**
   * @member {Integer} StrategicProgramStatusUpdateID
   */
  exports.prototype['StrategicProgramStatusUpdateID'] = undefined;
  /**
   * @member {Integer} WorkshopID
   */
  exports.prototype['WorkshopID'] = undefined;
  /**
   * @member {Integer} WorkshopWidgetID
   */
  exports.prototype['WorkshopWidgetID'] = undefined;
  /**
   * @member {Integer} MeetingID
   */
  exports.prototype['MeetingID'] = undefined;
  /**
   * @member {Integer} AlertID
   */
  exports.prototype['AlertID'] = undefined;
  /**
   * @member {Integer} DialogBatchID
   */
  exports.prototype['DialogBatchID'] = undefined;
  /**
   * @member {Integer} WorkspaceMindmapID
   */
  exports.prototype['WorkspaceMindmapID'] = undefined;
  /**
   * @member {String} DrillUri
   * @default ''
   */
  exports.prototype['DrillUri'] = '';
  /**
   * @member {String} DrillUriIconIdentifier
   * @default ''
   */
  exports.prototype['DrillUriIconIdentifier'] = '';
  /**
   * @member {Integer} InsightID
   * @default 0
   */
  exports.prototype['InsightID'] = 0;
  /**
   * @member {Integer} CategoryID
   * @default 0
   */
  exports.prototype['CategoryID'] = 0;
  /**
   * @member {String} DrillTitle
   * @default ''
   */
  exports.prototype['DrillTitle'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


